import React, { useState, useEffect, useCallback } from 'react';
import { motion } from 'framer-motion';
import { Package, MapPin } from 'lucide-react';
import { Navbar, Footer } from '../components/Layout';
import { PackageCard } from '../components/PackageCard';
import { QuoteForm } from '../components/QuoteForm';
import { promotionsAPI } from '../lib/api';

const Pacotes = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadPackages = useCallback(async () => {
    try {
      const response = await promotionsAPI.getAll();
      const pkgs = response.data.filter(p => p.is_package);
      setPackages(pkgs);
    } catch {
      // silently handled - UI shows empty state
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadPackages();
  }, [loadPackages]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      
      <section className="pt-24 sm:pt-28 pb-12 px-4 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="max-w-7xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="inline-flex items-center gap-2 bg-[#00A8B5]/20 text-[#00A8B5] px-4 py-2 rounded-full text-sm font-medium mb-6">
              <Package className="w-4 h-4" />
              Voo + Hospedagem
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4" data-testid="packages-hero-title">
              Pacotes Completos
            </h1>
            <p className="text-base sm:text-lg text-slate-300 max-w-2xl mx-auto mb-2">
              Viaje com tudo incluso: passagem aérea, hospedagem, transfer e muito mais.
            </p>
            <p className="text-sm text-slate-400">
              Preços por pessoa com todos os serviços inclusos
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-12 sm:py-16 px-4">
        <div className="max-w-7xl mx-auto">
          {loading ? (
            <div className="text-center py-16">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#00A8B5]"></div>
            </div>
          ) : packages.length === 0 ? (
            <div className="text-center py-16">
              <MapPin className="w-12 h-12 text-slate-300 mx-auto mb-4" />
              <p className="text-slate-600 text-lg" data-testid="no-packages">
                Nenhum pacote disponível no momento
              </p>
              <p className="text-slate-400 text-sm mt-2">
                Novos pacotes são adicionados regularmente. Volte em breve!
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="packages-grid">
              {packages.map((pkg, idx) => (
                <PackageCard key={pkg.id} promotion={pkg} index={idx} />
              ))}
            </div>
          )}
        </div>
      </section>

      <section id="cotacao" className="py-16 px-4 bg-slate-100">
        <div className="max-w-3xl mx-auto">
          <QuoteForm />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Pacotes;
